import React from "react";
import colors from "../../../../../../config/colors";
import { TextContainer } from "../CountBar/styles";
import { ChangeBarContainer, BarBox, Block, Divider } from "./styles";

/**
 *
 * This one has 4 possible sections
 * 1. The blank on the left
 * 2. The red if any
 * 3. The green if any
 * 4. The blank on the right
 */
function ChangeBar({ positiveRatio, data }) {
  let { value, normalizedValue } = data;
  let blocks = [];
  let negativeRatio = 1 - positiveRatio;
  const requiredPositiveRatioForText = 0.2;
  if (data.isNA) {
    return <ChangeBarContainer>NA</ChangeBarContainer>;
  }
  if (value < 0) {
    blocks.push({
      color: colors.darkBackground,
      width: (negativeRatio - normalizedValue) * 99,
      align: "right",
    });
    blocks.push({
      color: colors.red,
      width: normalizedValue * 99,
      text: positiveRatio < requiredPositiveRatioForText ? value.toFixed(1)+"%" : null,
      align: "right",
    });
    blocks.push({
      type: "divider",
    });
    blocks.push({
      color: colors.darkBackground,
      width: positiveRatio * 99,
      text: positiveRatio > requiredPositiveRatioForText ? value.toFixed(1)+"%" : null,
    });
  } else {
    blocks.push({
      color: colors.darkBackground,
      width: negativeRatio * 99,
    });
    blocks.push({
      type: "divider",
    });
    blocks.push({
      color: colors.green,
      width: normalizedValue * 99,
      text: normalizedValue > positiveRatio - normalizedValue ? value.toFixed(1)+"%" : null,
      align: "right",
    });
    blocks.push({
      color: colors.darkBackground,
      width: (positiveRatio - normalizedValue) * 99,
      text: normalizedValue < positiveRatio - normalizedValue ? value.toFixed(1)+"%" : null,
      align: "right",
    });
  }

  return (
    <ChangeBarContainer>
      <BarBox>
        {blocks.map(({ type, color, width, text }) => {
          if (type === "divider") {
            return <Divider />;
          }
          return (
            <Block color={color} width={width}>
              {text && <TextContainer>{text}</TextContainer>}
            </Block>
          );
        })}
      </BarBox>
    </ChangeBarContainer>
  );
}
export default ChangeBar;
